import TagManager from 'react-gtm-module';

const originalDataLayer = TagManager.dataLayer.bind(TagManager);

TagManager.dataLayer = (args = {}) => {
    if (
      args.dataLayer?.metadata &&
      typeof args.dataLayer.metadata === 'object'
    ) {
      args = {
        ...args,
        dataLayer: {
          ...args.dataLayer,
          metadata: JSON.stringify(args.dataLayer.metadata),
        },
      };
    }

    return originalDataLayer(args);
};